/* POO FORCE x KIMI — assets/pf-kimi.js (homepage, V9)
   Scroll reveal, count-up stats, sticky mobile CTA, header scrolled state,
   lazy ReviewHarvest.
   No dependencies. Loaded with defer by snippets/pf-kimi-head.
   Content is never hidden without JS: .pfk-reveal only hides once
   <html> has .pfk-js, which pf-kimi-head removes again if this file
   hasn't run within 2.5s. */
(function(){
  'use strict';
  window.PFK_READY = true;
  var doc = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* reveal */
  var rev = [].slice.call(document.querySelectorAll('.pfk-reveal'));
  if(!hasIO || reduced){ rev.forEach(function(el){ el.classList.add('is-visible'); }); }
  else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    rev.forEach(function(el){ io.observe(el); });
  }

  /* count-up (the HTML already holds the final numbers) */
  var nums = [].slice.call(document.querySelectorAll('[data-count]'));
  if(hasIO && !reduced && nums.length){
    var fmt = function(n){ return n.toLocaleString('en-US'); };
    var run = function(el){
      var target = parseInt(el.getAttribute('data-count'),10) || 0, t0 = null, dur = 1600;
      var tick = function(now){
        if(t0 === null) t0 = now;
        var p = Math.min((now - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.round(target * e));
        if(p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ run(en.target); cio.unobserve(en.target); } });
    }, {threshold:0.4});
    nums.forEach(function(el){
      if(el.getBoundingClientRect().top > window.innerHeight){ el.textContent = '0'; cio.observe(el); }
    });
  }

  /* sticky mobile CTA + header shadow.
     The bar is hidden whenever ANY part of the estimator (questions, price
     card, request form) is on screen, and while anyone is typing in a
     form, so it can never cover the calculator or signup fields. */
  var sticky = document.querySelector('[data-sticky]');
  var est = document.getElementById('estimate');
  var typing = false;
  var ticking = false;
  var onScroll = function(){
    ticking = false;
    var y = window.scrollY || window.pageYOffset, vh = window.innerHeight;
    doc.classList.toggle('pfk-scrolled', y > 24);
    if(sticky){
      var near = false;
      if(est){ var r = est.getBoundingClientRect(); near = r.top < vh && r.bottom > 0; }
      sticky.classList.toggle('is-on', y > vh * 0.75 && !near && !typing);
    }
  };
  if(est){
    document.addEventListener('focusin', function(e){ if(est.contains(e.target) || e.target.closest('form')){ typing = true; onScroll(); } });
    document.addEventListener('focusout', function(){ typing = false; onScroll(); });
  }

  /* ReviewHarvest, loaded only when the reviews are about to be seen
     (saves its script and images on every visit that never gets there) */
  [].slice.call(document.querySelectorAll('[data-rh-lazy]')).forEach(function(box){
    var load = function(){
      if(box.getAttribute('data-rh-done')) return;
      box.setAttribute('data-rh-done','1');
      var sc = document.createElement('script'); sc.async = true; sc.src = box.getAttribute('data-rh-lazy');
      document.body.appendChild(sc);
      var tries = 0, t = setInterval(function(){
        var c = box.querySelector('.pf-reviews');
        if((c && (c.children.length || c.shadowRoot)) || ++tries > 40){ box.classList.add('is-loaded'); clearInterval(t); }
      }, 250);
    };
    if(hasIO){
      var rio = new IntersectionObserver(function(en){ if(en[0].isIntersecting){ load(); rio.disconnect(); } }, {rootMargin:'600px 0px'});
      rio.observe(box);
    } else { load(); }
  });
  window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, {passive:true});
  onScroll();
})();
